import Head from 'next/head';
import Link from 'next/link';
import Tabs from '@/components/CookieTabs';

const Page = () => {
  return (
    <>
      <Head>
        <title>Cookie-Hinweis</title>
      </Head>

      <h1>Cookie-Hinweis</h1>
      <div className="row mt-5">
        <div className="col-md-6">
          <div className="alert alert-info">
            <h2>Mustertext für den Cookie-Hinweis</h2>
            <p>
              <i>
                Indem Sie diesen Hinweis schliessen oder mit dem Besuch der
                Seite fortfahren, akzeptieren Sie die Verwendung von Cookies.
                Weitere Informationen dazu finden Sie unter Datenschutz.
              </i>
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <h2>Datenschutz FHNW</h2>
          <p>
            <i>
              Inhaltlich richtige und aktuelle Informationen sind der
              Fachhochschule Nordwestschweiz wichtig. Es ist deshalb möglich,
              dass Inhalte unserer Website ganz oder teilweise geändert,
              gelöscht oder (zeitweise) nicht mehr veröffentlicht werden. Eine
              ausführliche Dokumentation finden Sie in folgendem Link:{' '}
            </i>
            <Link
              href="https://www.fhnw.ch/de/impressum/datenschutz"
              passHref
              legacyBehavior
            >
              <a target="_blank">
                <i>Datenschutz FHNW</i>
              </a>
            </Link>
          </p>
        </div>
      </div>

      <h2 className="mt-5">Cookie-Banner</h2>

      <div className="col-12">
        <div
          className="alert alert-secondary bg-black"
          role="alert"
          aria-label="Datenschutz und Cookies"
          aria-hidden="false"
        >
          <div className="row">
            <div className="col-10">
              <p className="text-white">
                Indem Sie diesen Hinweis schliessen oder mit dem Besuch der
                Seite fortfahren, akzeptieren Sie die Verwendung von Cookies.
                Weitere Informationen dazu finden Sie unter{' '}
                <a
                  className="text-white"
                  href="https://www.fhnw.ch/de/impressum/datenschutz"
                  target="_blank"
                >
                  Datenschutz
                </a>
                .
              </p>
            </div>
            <div className="col-2 mt-3">
              <button
                type="button"
                className="btn btn-secondary btn-sm acceptcookies float-right pl-3 pr-3"
                aria-label="Schliessen"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12">
        <Tabs />
      </div>
    </>
  );
};

export default Page;
